// extracted by mini-css-extract-plugin
module.exports = {"errorText":"Header_errorText__33SVE","pendingMessage":"Header_pendingMessage__2H7tA","container":"Header_container__LFHHL","text":"Header_text__2L4a_"};